"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContainer = TableContainer;
exports.TableRow = TableRow;
const React = __importStar(require("react"));
const Row = __importStar(require("./table-row"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const LocalElements = __importStar(require("../elements"));
function TableContainer({ children }) {
    return (React.createElement(Elements.FlexContainerStack, { center: false, centerVertically: false },
        React.createElement(LocalElements.ResultTableContainer, null,
            React.createElement(LocalElements.ResultTable, null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Name"),
                        React.createElement("th", null, "System type"),
                        React.createElement("th", null, "Reference system"),
                        React.createElement("th", null, "Test system"),
                        React.createElement("th", null, "Status"))),
                React.createElement("tbody", null, children)))));
}
function TableRow(props) {
    return React.createElement(Row.Container, Object.assign({}, props));
}
//# sourceMappingURL=container.js.map